/**
 * Synchronizes the search modal and menu drawer to ensure only one is open at a time.
 * When one opens, the other automatically closes.
 */

class ModalDrawerSync {
  constructor() {
    this.searchModal = document.getElementById('search-modal');
    this.menuDrawer = document.getElementById('Details-menu-drawer-container');
    this.headerDrawer = this.menuDrawer?.closest('header-drawer');
    
    this.init();
  }

  init() {
    if (!this.searchModal || !this.menuDrawer || !this.headerDrawer) {
      console.warn('ModalDrawerSync: Required elements not found');
      return;
    }

    // Listen for search modal open events
    this.searchModal.addEventListener('dialog:open', this.handleSearchModalOpen.bind(this));

    this.observeMenuDrawer();
    
    // Listen for clicks on search button to close menu drawer
    this.setupSearchButtonListener();
    
    // Listen for clicks on menu button to close search modal
    this.setupMenuButtonListener();
  }

  /**
   * Handle search modal opening - close menu drawer if it's open
   */
  handleSearchModalOpen() {
    if (this.menuDrawer.hasAttribute('open')) {
      this.headerDrawer.close();
    }
  }

  observeMenuDrawer() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (this.menuDrawer.hasAttribute('open')) {
            this.handleMenuDrawerOpen();
          }
        }
      });
    });

    observer.observe(this.menuDrawer, {
      attributes: true,
      attributeFilter: ['open']
    });
  }

  handleMenuDrawerOpen() {
    if (this.searchModal && this.isSearchModalOpen()) {
      this.searchModal.closeDialog();
    }
  }

  setupSearchButtonListener() {
    const searchButton = document.querySelector('[on\\:click*="search-modal/showDialog"]');
    if (searchButton) {
      searchButton.addEventListener('click', () => {
        if (this.menuDrawer.hasAttribute('open')) {
          this.headerDrawer.close();
        }
      });
    }
  }

  setupMenuButtonListener() {
    const menuButton = this.menuDrawer.querySelector('summary');
    if (menuButton) {
      menuButton.addEventListener('click', () => {
        if (this.isSearchModalOpen()) {
          this.searchModal.closeDialog();
        }
      });
    }
  }

  isSearchModalOpen() {
    const dialog = this.searchModal.querySelector('[role="dialog"]');
    return dialog && dialog.classList.contains('is-open');
  }
}

let modalDrawerSyncInstance;
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    modalDrawerSyncInstance = new ModalDrawerSync();
    window.modalDrawerSync = modalDrawerSyncInstance;
  });
} else {
  modalDrawerSyncInstance = new ModalDrawerSync();
  window.modalDrawerSync = modalDrawerSyncInstance;
}
